/**
 * Adapter — CustomerOfferFavoriteListItemDTO → PublicDiscoveryOfferItemDTO
 * so Screen 6 bag row open can reuse DiscoveryOfferDetailSheet / shop handoff.
 */

import type { CustomerOfferFavoriteListItemDTO } from '../account/offerFavoritesTypes.js';
import type { PublicDiscoveryOfferItemDTO } from '../discovery/publicDiscoveryTypes.js';

export function mapOfferFavoriteToDiscoveryOffer(
  item: CustomerOfferFavoriteListItemDTO,
): PublicDiscoveryOfferItemDTO {
  const tenantCode = item.tenantContext.tenantCode;
  const code = item.salesPointContext.code;
  const shopPath =
    code.trim().length > 0
      ? `/${encodeURIComponent(tenantCode)}/${encodeURIComponent(code)}`
      : `/${encodeURIComponent(tenantCode)}`;

  return {
    resultType: 'offer',
    title: item.title,
    subtitle: item.salesPointContext.name,
    description: null,
    imageUrl: item.imageUrl,
    thumbnailUrl: item.thumbnailUrl,
    price: item.price,
    distanceMeters: null,
    relevanceScore: 0,
    platformCategory: null,
    intentContext: {
      productServiceKey: `bag:${item.productContext.productId}`,
      productServiceLabel: item.title,
      matches: { productService: true, category: false, tenant: false },
    },
    tenantContext: {
      tenantId: item.tenantContext.tenantId,
      tenantCode,
      tenantName: item.tenantContext.tenantName,
    },
    salesPointContext: {
      salesPointId: item.salesPointContext.salesPointId,
      code,
      name: item.salesPointContext.name,
      customerShopUrl: shopPath,
      lat: null,
      lng: null,
    },
    productContext: {
      productId: item.productContext.productId,
      variantId: item.productContext.variantId,
    },
    gpsr: null,
  };
}
